export const includesValidator = (values) => (v) => Object.values(values).includes(v);

export const includesKeyInObjectValidator = (keys) => (v) => typeof v === 'object' && keys.every((key) => key in v);

export const includesKeyInArrayObjectsValidator = (keys) => {
  const validateElKeys = includesKeyInObjectValidator(keys);
  return (v) => v.every((el) => validateElKeys(el));
};
